export default __webpack_public_path__ + "static/media/student-img.45cfefa2.jpg";